
export const CLEAR_STATE = 'CLEAR_STATE'; //Action to reset redux state


// WEBPACK FOOTER //
// ./src/App/constants.js